'use client'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import EmbedEmissionCalcsAnimation from '@/components/MovingChipAnimation/EmbedEmissionCalcsAnimation'
import useDevice from '@/hooks/useDevice'

const ScaleYourEmissionCalculations = () => {
    const { xsScreen, smScreen, mdScreen } = useDevice()
    return (
        <>
            <Box>
                <Text
                    variant={mdScreen ? 'h5' : 'h4'}
                    sx={{ mb: 4, width: '100%', textAlign: smScreen ? 'left' : 'center' }}
                >
                    Deliver scalable calculations your way {!xsScreen && <br />}
                    with 50,000 emissions factors
                </Text>
                <Text
                    variant={mdScreen ? 'body2' : 'body1'}
                    sx={{ mb: 9, textAlign: smScreen ? 'left' : 'center' }}
                >
                    <>
                        Plug the information you have at hand into our flexible data inputs. Using
                        almost 50,000 of spend- and activity-based emissions factors, our
                        calculations are optimised for scope 3 emissions across logistics,
                        procurement, and purchases.
                    </>
                </Text>
                <EmbedEmissionCalcsAnimation />
            </Box>
        </>
    )
}

export default ScaleYourEmissionCalculations
